import { closeWithSideEffect } from '@espoon-voltti/react-voltti/components/modal'

import { GlobalModal } from '@espoon-voltti/nuora-app-common/globals'
import { handleError as handleErrorCommon } from '@espoon-voltti/nuora-app-common/error-handling/error-handler'

import * as Session from '../session'
import { t } from '../i18n'

const onUnauthorizedError = () =>
  GlobalModal.get().show(
    {
      title: t(['common', 'modal', 'sessionExpired', 'title']),
      text: t(['common', 'modal', 'sessionExpired', 'text']),
      dataQa: 'sessionExpired',
      id: 'sessionExpired'
    },
    closeWithSideEffect(() => Session.home())
  )

const onError = () =>
  GlobalModal.get().show({
    title: t(['common', 'modal', 'defaultError', 'title']),
    text: t(['common', 'modal', 'defaultError', 'text']),
    dataQa: 'defaultError',
    id: 'defaultError'
  })

export const handleError = handleErrorCommon(onUnauthorizedError, onError)
